/** Podręczne kolory dla kształtów, tekstu i tła. Pierwszy rząd to paleta marki. */
export const COLOR_SWATCHES = [
  '#0f3333', '#1a4d4d', '#18a785', '#c18344', '#f7f7f7', '#ffffff',
  '#f4f4f5', '#a1a1aa', '#3f3f46', '#18181b', '#000000', '#1a4d6d',
  '#0b4f9e', '#1a4d6d', '#0ea5e9', '#06b6d4', '#14b8a6', '#18a785',
  '#facc15', '#f59e0b', '#f97316', '#ef4444', '#dc2626', '#be123c',
  '#c18344', '#a16207', '#7c3aed', '#a855f7', '#ec4899', '#f472b6',
];

export interface GradientPreset {
  label: string;
  from: string;
  to: string;
  angle: number;
}

export const GRADIENT_PRESETS: GradientPreset[] = [
  { label: 'Hotelspot', from: '#0f3333', to: '#1a4d4d', angle: 135 },
  { label: 'Zieleń', from: '#0f3333', to: '#18a785', angle: 150 },
  { label: 'Złoto marki', from: '#1a4d4d', to: '#c18344', angle: 130 },
  { label: 'Ocean', from: '#0b4f9e', to: '#0ea5e9', angle: 135 },
  { label: 'Zachód słońca', from: '#f97316', to: '#be123c', angle: 135 },
  { label: 'Złoto', from: '#c18344', to: '#facc15', angle: 120 },
  { label: 'Mięta', from: '#14b8a6', to: '#a7f3d0', angle: 160 },
  { label: 'Noc', from: '#18181b', to: '#3f3f46', angle: 145 },
  { label: 'Fiolet', from: '#7c3aed', to: '#ec4899', angle: 135 },
];
